module.exports = __webpack_public_path__ + "media/images/new-icon-0a540588b358331595a9eeeb085f5a5c.svg";